import { forceRefetchAlertBannerRoutes } from "@faire/retailer-visitor-shared/packages/core/services/AlertBanner/consts";
import { useInvalidateQuery as useInvalidateGetNotificationQuery } from "@faire/web-api--source/endpoints/www/api/retailer/notifications/get-hooks";
import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

export const useNotificationRefetch = () => {
  const invalidateGetNotificationQuery = useInvalidateGetNotificationQuery();
  const { pathname } = useLocation();
  const prevRoute = useRef("");

  const shouldForceRefetchNotifications = (routes: string[]) => {
    return routes.some((route) =>
      forceRefetchAlertBannerRoutes.includes(route)
    );
  };

  useEffect(() => {
    if (shouldForceRefetchNotifications([pathname, prevRoute.current])) {
      invalidateGetNotificationQuery();
    }

    // Update the previous route after the check
    prevRoute.current = pathname;
  }, [pathname, invalidateGetNotificationQuery]);
};
